/* eslint-disable indent */
export enum SefaTypeEnum {
    AsalahAnNafseh = 1,
    Lawyer = 2,
    Authorizer = 3,
    Entity = 4,
    AttorneyAgent = 5,
    StudentWali = 6,
    Wali = 7,
    Wasi = 8,

}

export interface SefaTypeEnumDisplayNames {
    [key: number]: string;
}

export const SefaTypeEnumDisplayNames: SefaTypeEnumDisplayNames = {
    [SefaTypeEnum.AsalahAnNafseh]: 'أصالة عن نفسه',
    [SefaTypeEnum.Lawyer]: 'محامي',
    [SefaTypeEnum.Authorizer]: 'ممثل نظامي',
    [SefaTypeEnum.Entity]: 'منشأة',
    [SefaTypeEnum.AttorneyAgent]: '"وكيل بموجب وكالة',
    [SefaTypeEnum.StudentWali]: 'ولي على طالب',
    [SefaTypeEnum.Wali]: 'ولي',
    [SefaTypeEnum.Wasi]: 'وصي بموجب صك وصية',
};
